import { useCallback, useRef } from 'react';
/**
 * Hook to play a sound when stream completes
 * @returns Function to play the completion sound
 */ export function useStreamCompleteSound() {
    const audioRef = useRef(null);
    const playCompletionSound = useCallback(()=>{
        try {
            // Lazy-load the audio element
            if (!audioRef.current) {
                audioRef.current = new Audio('/sounds/complete_sound.wav');
                // Preload the audio for faster playback
                audioRef.current.preload = 'auto';
            }
            // Play the sound
            const playPromise = audioRef.current.play();
            // Handle play promise (required for some browsers)
            if (playPromise !== undefined) {
                playPromise.catch((error)=>{
                    // User hasn't interacted with document yet, or autoplay policy blocked it
                    console.debug('Could not play completion sound:', error);
                });
            }
        } catch (error) {
            // Silently fail if audio playback is not supported
            console.debug('Audio playback error:', error);
        }
    }, []);
    return playCompletionSound;
}
